/**
 * The strands on a LIGHT (frosted white) surface. The dark pass is additive light whose alpha follows its luminance,
 * so on white its white-hot cores vanish and its glow washes out. The light pass lays each strand down like ink
 * instead (normal alpha): a crisp line over a soft halo of its own bright colour. Shader controls only: the palette
 * stays STRANDS_COLORS and the motion stays STRANDS_CFG.
 */
export const STRANDS_LIGHT = {
  /** Hue-kept deepening: a colour lighter than this luma (Rec. 709 weights on the sRGB values) is scaled down to it,
   *  so the bright cyan reads on white while the orange and magenta keep their own depth (the light theme's rule for
   *  neons: same hue, deepened). */
  inkLuma: 0.56,
  /** How quickly a strand's line turns opaque along its profile: higher draws a fuller line. */
  body: 0.62,
  /** The halo's peak opacity. Its colour is the bright palette colour, so on white it reads as a pastel glow. */
  haloAlpha: 0.45,
  /** How far the halo spreads around the line: higher reaches further out. */
  haloReach: 6,
  /** The colour the palette's wrap (last colour back to the first) passes through: cyan blended straight into orange
   *  is grey mud on white, so it goes through Lumio's violet instead, taken from the palette itself (`at` of the way
   *  from STRANDS_COLORS[from] to STRANDS_COLORS[to], magenta to cyan). */
  bridge: { from: 1, to: 2, at: 0.4 },
} as const;
